module.exports = __webpack_public_path__ + "img/home3.22489edd.jpg";